import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CFormInput,
  CRow,
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { garmentState, setService } from 'src/reduxToolkit/slice/garmentShorting'
import { get, post } from 'src/utils/apiManager'
import Swal from 'sweetalert2'

const AddItemService = () => {
  let { search } = useLocation()
  let pramasData = useParams()
  const [serviceNameValue, setServiceNameValue] = useState("")
  const { service } = useSelector(garmentState)
  const [serviceData, setServiceData] = useState([])
  const [serviceError, setServiceError] = useState("")
  const dispatch = useDispatch()
  const [selectedService, setSelectedService] = useState('')
  const { bagId, orderId } = useParams()
  const [amount, setAmount] = useState('')
  const [errors, setErrors] = useState({})
  const { state } = useLocation()

  useEffect(() => {
    get(`/admin/subscription/services`).then((data) => {
      setServiceData(data?.data)
    })
  }, [])

  useEffect(() => {
    if (search !== "") {
      dispatch(setService(search?.split("?serviceName=")?.[1]))
    }
  }, [search, dispatch])

  useEffect(() => {
    let bag = state?.bags?.find((val) => val._id?.toString() === (bagId || pramasData?.bagId)?.toString());
    if (bag) {
      if (bag.unitValue && bag.unitValue !== '0' && bag.unitValue !== '1') {
        setAmount(bag.unitValue);
      }
    } else if (bagId) {
      get(`/admin/offline-order/get-order-bag/${bagId}`).then((data) => {
        if (data?.status && data?.data?.[0]) {
          const bagObj = data.data[0];
          if (bagObj?.unitValue && bagObj.unitValue !== '0' && bagObj.unitValue !== '1') {
            setAmount(bagObj.unitValue);
          }
        }
      });
    }
  }, [bagId, state, pramasData]);

  const navigate = useNavigate();

  const isWashAndFold = (item) => {
    if (!item) return false;
    const unitTitle = item?.unit?.title_EN?.toLowerCase();
    const serviceName = item?.serviceName_EN?.toLowerCase();
    return unitTitle === 'kg' || (serviceName && (serviceName.includes('wash & fold') || serviceName.includes('wash&fold') || serviceName.includes('wash and fold')));
  };

  const submitData = (id) => {
    let bag = state?.bags?.find((val) => val._id?.toString() === (bagId || pramasData?.bagId)?.toString());

    if (bag?.serviceType && bag.serviceType !== id) {
      Swal.fire({
        title: 'Are you sure you want to change services?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        customClass: {
          actions: 'my-actions',
          confirmButton: 'order-2',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.localStorage.setItem('categoryId', id)
          setErrors({})
          dispatch(setService(id))

          const newServiceObj = serviceData?.find((item) => item._id === id);
          const isKg = isWashAndFold(newServiceObj);
          const payload = { serviceType: id };
          if (!isKg) {
            setAmount('');
          } else if (amount && !isNaN(amount) && Number(amount) > 0) {
            payload.unitValue = String(amount);
          }

          post(`admin/offline-order/bag/edit-bag/${bagId}`, payload, 0).then(
            (data) => {
              console.log({ data })
            },
          )
        }
      })
    } else {
      setErrors({})
      dispatch(setService(id))
      const newServiceObj = serviceData?.find((item) => item._id === id);
      const isKg = isWashAndFold(newServiceObj);
      if (!isKg) {
        setAmount('');
      }
    }
  }

  const nextPage = () => {
    navigate(`/admin/offline-order/bag/${bagId}/${orderId}`)
  }

  const prevPage = () => {
    navigate(`/admin/offline-order/bags/${orderId}`)
  }

  const handleNext = () => {
    if (!service) {
      setServiceError('Please select a service')
      return
    }

    const selectedServiceObj = serviceData?.find((item) => item._id === service);
    const isKgService = isWashAndFold(selectedServiceObj);

    if (isKgService) {
      if (!amount || isNaN(amount) || Number(amount) <= 0) {
        setErrors((prevState) => ({ ...prevState, [service]: 'Please enter a valid weight in kg' }));
        return;
      }
    }

    setServiceError('')
    dispatch(setService(service))

    const payload = { serviceType: service };
    if (isKgService && amount) {
      payload.unitValue = String(amount);
    }

    post(`admin/offline-order/bag/edit-bag/${bagId}`, payload, 0)
      .then((data) => {
        console.log({ data })
      })
    window.localStorage.setItem("categoryId", service);
    nextPage()
  }

  const handleOnBlur = (id, value) => {
    if (value && !isNaN(value) && Number(value) > 0) {
      setErrors((prevState) => ({ ...prevState, [id]: null }))
    } else {
      setErrors((prevState) => ({ ...prevState, [id]: 'Please enter a valid weight in kg' }))
    }
  }

  return (
    <CContainer>
      <CCard>
        <CCardGroup>
          <CCardBody>
            <CRow className="p-2 align-items-center">
              <CCol>
                <h5 style={{ textTransform: 'uppercase' }}>Service </h5>
              </CCol>
            </CRow>
            <hr />
            {serviceError && (
              <div style={{ color: 'red', marginBottom: '10px', textAlign: 'center', fontWeight: 'bold' }}>
                {serviceError}
              </div>
            )}
            <CRow className="p-2 align-items-center">
              {serviceData?.length > 0 &&
                serviceData.map((data, index) => {
                  const isKgService = isWashAndFold(data);
                  const isSelected = service === data?._id;
                  return (
                    <CCol xs={3} key={index} className="my-2">
                      <div style={{ position: 'relative' }}>
                        <div
                          onClick={() => submitData(data._id)}
                          className="card p-4 w-100 d-flex align-items-center justify-content-center text-center my-2"
                          style={{
                            wordBreak: 'break-all',
                            cursor: 'pointer',
                            borderColor: isSelected ? '#d3dc40' : undefined,
                            borderWidth: isSelected ? '2px' : undefined,
                            backgroundColor: isSelected ? '#fafceb' : undefined,
                          }}
                        >
                          {data.serviceName_EN}
                        </div>
                        {isSelected && (
                          <div
                            style={{ position: 'absolute', top: 0, right: '10%', fontSize: '24px' }}
                          >
                            <i className="fa-solid fa-check"></i>
                          </div>
                        )}
                        {/* Only show weight input for Wash & Fold when it is selected */}
                        {isKgService && isSelected && (
                          <div className="mt-2" onClick={(e) => e.stopPropagation()}>
                            <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#444', marginBottom: '4px', display: 'block' }}>
                              Weight (KG):
                            </label>
                            <CFormInput
                              type="number"
                              step="0.01"
                              min="0.01"
                              placeholder="e.g. 5.29"
                              value={amount}
                              onChange={(e) => {
                                const val = e.target.value;
                                setAmount(val);
                                if (errors[data?._id]) {
                                  setErrors((prevState) => ({ ...prevState, [data?._id]: null }));
                                }
                              }}
                              onBlur={(e) => handleOnBlur(data._id, e.target.value)}
                              style={{
                                borderColor: errors[data?._id] ? 'red' : '#d3dc40',
                                borderWidth: '1.5px',
                              }}
                            />
                            {errors[data?._id] && (
                              <div style={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>
                                {errors[data?._id]}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </CCol>
                  );
                })}
              <CCol xs={3}>
                <div style={{ position: 'relative' }}>
                  <div
                    onClick={() => navigate('/admin/services')}
                    className="card p-4 w-100 d-flex align-items-center justify-content-center text-center my-2"
                    style={{ wordBreak: 'break-all', cursor: 'pointer' }}
                  >
                    Add more & Delete
                  </div>
                </div>
              </CCol>
            </CRow>

            <CRow className="justify-content-between">
              <CCol xs={2} className="justify-content-end">
                {service !== '' && (
                  <button
                    style={{
                      marginTop: '20px',
                      width: '100%',
                      background: '#d3dc40',
                      border: '#d3dc40',
                      padding: '10px 0',
                    }}
                    onClick={() => prevPage()}
                  >
                    prev
                  </button>
                )}
              </CCol>
              <CCol xs={2} className="justify-content-end">
                {service !== '' && (
                  <button
                    style={{
                      marginTop: '20px',
                      width: '100%',
                      background: '#d3dc40',
                      border: '#d3dc40',
                      padding: '10px 0',
                    }}
                    onClick={handleNext}
                  >
                    Next
                  </button>
                )}
              </CCol>
            </CRow>
          </CCardBody>
        </CCardGroup>
      </CCard>
    </CContainer>
  )
}

export default AddItemService
